import React from "react";

// Components
import GenericTable from "../_common/GenericTable.react";

// Query
import clientCsatReview from "../../../../queries/client_csat_review";

// Schemas
import ticketTableSchema from "../../../../schemas/tickets";

class CSATs extends React.Component {
	render() {
		return (
			<GenericTable
				components={this.props.components}
				clientId={this.props.item.id}
				title={"Negative CSATs needing review"}
				query={clientCsatReview}
				where={[
					{ name: "clientId", operator: "=", value: this.props.item.id },
					{ name: "deleted", operator: "=", value: 0 }
				]}
				orderBy={"requesterUpdated"}
				orderByDirection={"asc"}
				schema={ticketTableSchema}
				type={"tickets"}
				view={this.props.localData.view}
			/>
		);
	}
}

export default CSATs;
